<template>
  <div class="modal fade" id="require-use-warehouse-modal" role="dialog" @click="$emit('close')">
    <div class="modal-dialog modal-lg" @click.stop>
      <div class="modal-dialog modal-lg">
        <div class="modal-content additonal-modal-content bd-rds-16">
          <div class="pd-t-20 pd-b-20 pd-l-5 pd-r-5">
            <div class="flex flex-flow-column flex-content-center font-bold text-size-20 pd-l-100 pd-r-100 text-plan-normal gap-10">
              <div class="text-size-24">
                STOCKCREW倉庫をご利用いただくためには、<br>
                倉庫管理画面より
                <span class="text-dark-red">STOCKCREW倉庫を追加</span>
                していただくようにお願いします。
              </div>
              <button class="btn btn-warning btn-shadow btn-upgrade-plan bd-rds-8 text-size-22 pd-t-20 pd-b-15 pd-r-100 pd-l-100 mr-t-10" @click="$emit('close'); $router.push('/warehouses')">
                倉庫管理画面はこちら
                <i class="fa fa-arrow-circle-right fa-lg" aria-hidden="true"></i>
              </button>
              <a @click="$emit('close')" class="text-size-14 mr-t-20">閉じる</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      loader: null
    }
  },
  mounted () {
    $('#require-use-warehouse-modal').modal('show')
  },
  beforeDestroy () {
    this.$emit('close')
    $('.modal-backdrop').remove()
  }
}
</script>
<style scoped>
  .modal-dialog {
    margin-top: 200px;
  }
  @media (min-width: 1024px) {
    .modal-lg {
      width: 800px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/warehouseAcross/components/RequireUseScWarehouseModal.vue